import { TFunction } from 'i18next';

export const paymentAgreementSidekicker = (t: TFunction): string =>
  t(
    'subscription:payment_form.agreement_sidekicker',
    'AV Wellbeing Limited. Florinis, 7, Greg Tower, 2nd floor, 1065, Nicosia, Cyprus',
  );
